import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';
import { ProductService } from '../services/product.service';

export const storyblokProductsResolver: ResolveFn<unknown> = route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  const productService = inject(ProductService);

  return storyblokService.getUniqueComponentsList(route).pipe(
    switchMap(components => {
      if (components.has('PricingBoxList') || components.has('ProductComparisonList')) {
        return productService.getAllListedProducts();
      }
      return of(undefined);
    })
  );
};
